/**
 * Mensagens de erro centralizadas
 */

/**
 * Mensagens de erro retornadas pela API (devem corresponder às mensagens do backend)
 */
export const ERROR_MESSAGES = {
  INVALID_CREDENTIALS: 'Credenciais inválidas',
  NO_BRANCH_MEMBERSHIP: 'Usuário não possui vínculos com uma filial',
  SELECTED_BRANCH_NOT_FOUND_IN_MEMBERSHIPS:
    'Filial selecionada não encontrada nos vínculos do usuário',
  API_TOKEN_INVALID_OR_EXPIRED: 'Token inválido ou expirado',
  MUST_CHANGE_PASSWORD: 'Usuário deve alterar a senha no primeiro acesso',
} as const;

/**
 * Mensagens de erro do lado do cliente (fallbacks e mensagens de UI)
 */
export const CLIENT_ERROR_MESSAGES = {
  AUTH_SESSION_EXPIRED: 'Autenticação expirada. Entre no sistema novamente',
} as const;

export const TOAST_TITLES = {
  ERROR: 'Erro',
} as const;

/**
 * Gera mensagem de erro para arquivo que excede o limite de tamanho
 * @param maxSizeMB - Tamanho máximo permitido em MB
 * @returns Mensagem de erro formatada
 */
export const FILE_SIZE_EXCEEDS_LIMIT = (maxSizeMB: number): string =>
  `Ops! O arquivo enviado excede o limite de ${maxSizeMB} MB. Envie um arquivo de até ${maxSizeMB} MB para concluir o upload.`;

/**
 * Gera mensagem de erro para quando o limite de arquivos por upload é excedido
 * @param maxFiles - Número máximo de arquivos permitidos
 * @returns Mensagem de erro formatada
 */
export const FILE_COUNT_EXCEEDS_LIMIT = (maxFiles: number): string =>
  `Ops! Parece que você tentou enviar mais de ${maxFiles} arquivos de uma vez. Você pode enviar até ${maxFiles} arquivos, tente novamente.`;

/**
 * Gera mensagem de erro para quando o limite de arquivos já foi atingido
 * @param maxFiles - Número máximo de arquivos permitidos
 * @returns Mensagem de erro formatada
 */
export const FILE_COUNT_LIMIT_REACHED = (maxFiles: number): string =>
  `Você já atingiu o limite de ${maxFiles} arquivos. Remova alguns arquivos antes de adicionar novos.`;

export const DUPLICATE_PREFIXES_IN_BATCH_MESSAGE =
  'Existem arquivos com prefixos duplicados no lote. Verifique e tente enviar novamente.';

export const PREFIX_ALREADY_IN_PROGRESS_MESSAGE =
  'Existem documentos em homologação ou aguardando vigência com um ou mais dos prefixos selecionados. Remova os documentos conflitantes e tente novamente.';
